import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { useAuthStore } from "@/stores/auth-store";
import { Topbar } from "@/components/topbar";
import { Sidebar } from "@/components/sidebar";
import { AUTH_ROUTES } from "@/utils/navigation";
import { BreadcrumbNav } from "@/components/breadcrumb-nav";
import { useBreadcrumb } from "@/hooks/use-breadcrumb";
import { useManagementMode } from "@/hooks/use-management-mode";

export const Route = createFileRoute("/(protected)")({
  beforeLoad: () => {
    const authStore = useAuthStore.getState();
    if (!authStore.isAuthenticated()) {
      throw redirect({
        to: AUTH_ROUTES.SIGN_IN,
      });
    }
  },
  component: RouteComponent,
});

function RouteComponent() {
  const { breadcrumbs, hasActionButtons, navigate } = useBreadcrumb();
  const { isManagementArea } = useManagementMode();
  const spacing = hasActionButtons ? "pr-64" : "";

  return (
    <div className="flex h-screen max-w-screen min-w-[309px] overflow-x-auto">
      <Sidebar />

      <div
        className={`flex min-w-0 flex-1 flex-col pb-2 transition-all duration-300 md:pr-4 ${isManagementArea ? "bg-gray-150 dark:bg-gray-900" : "bg-white dark:bg-gray-800"}`}
      >
        <Topbar />

        <main
          className={`relative flex flex-1 flex-col overflow-hidden bg-gray-50 md:rounded-2xl md:border md:border-gray-300 dark:text-white ${isManagementArea ? "dark:bg-gray-800 md:dark:border-gray-800" : "dark:bg-gray-900 md:dark:border-gray-900"}`}
        >
          <div className="hidden md:block md:px-6 md:pt-6">
            <div className={`flex min-h-10 items-center gap-4 ${spacing}`}>
              <BreadcrumbNav
                items={breadcrumbs}
                onNavigate={navigate}
                className="min-w-0 flex-1"
                hasActionButtons={hasActionButtons}
              />
            </div>
          </div>
          <div className="flex flex-1 flex-col overflow-hidden">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
